export default __webpack_public_path__ + "static/microsoft-6913667979f4a05f9aa839d0d43b3388.png";